var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiceD4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M231.627 0C235.77 0 239.812 3.31 239.812 8.524V503.457C239.812 508.529 235.856 512 231.66 512C229.936 512 228.171 511.414 226.624 510.113L3.026 321.302C1.037 319.621 0 317.154 0 314.66C0 312.844 0.55 311.012 1.682 309.459L225.281 3.337C226.971 1.031 229.315 0 231.627 0ZM512 314.66C512 317.154 510.963 319.621 508.974 321.302L285.376 510.113C283.829 511.414 282.064 512 280.34 512C276.144 512 272.188 508.529 272.188 503.457V8.524C272.188 3.31 276.23 0 280.373 0C282.685 0 285.029 1.031 286.719 3.337L510.318 309.459C511.45 311.012 512 312.844 512 314.66Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceD4);
export default __webpack_public_path__ + "static/media/dice-d4.4063883d3a87642bf58aa22adb340a26.svg";
export { ForwardRef as ReactComponent };